import { SocraticDialogueFragment } from "@/generated/graphql";

/**
 * Checks if a Socratic Dialogue has a response (i.e. if the student has
 * completed their attempt)
 */
export function hasDialogueResponse(
  dialogue: SocraticDialogueFragment
): boolean {
  if (dialogue.turns.length === 0) {
    return false;
  } else {
    const [turn] = dialogue.turns;
    return turn?.response?.mediaUrl != null;
  }
}

/**
 * Whether the student has at least one completed (submitted) response across
 * all their dialogues.
 */
export function hasCompletedResponse(
  dialogues: SocraticDialogueFragment[]
): boolean {
  return dialogues.some(hasDialogueResponse);
}
